import React from 'react';

interface ResponsiveContainerProps {
    children: React.ReactNode;
    className?: string;
    id?: string;
}

export const responsivePadding = "px-[calc((100%-20.5rem)/2)] sm:px-[calc((100%-33.5rem)/2)] md:px-[calc((100%-53.563rem)/2)] lg:px-[calc((100%-55rem)/2)] xl:px-[calc((100%-70.5rem)/2)]"

export const responsivePaddingLeft = "pl-[calc((100%-20.5rem)/2)] sm:pl-[calc((100%-33.5rem)/2)] md:px-[calc((100%-53.563rem)/2)] lg:px-[calc((100%-55rem)/2)] xl:px-[calc((100%-70.5rem)/2)]"

const ResponsiveContainer: React.FC<ResponsiveContainerProps> = ({ children, className, id }) => {
    const containerClasses = `w-[20.5rem] sm:w-[33.5rem] md:w-[53.563rem] lg:w-[55rem] xl:w-[70.5rem] ${className}`

    return (
        <div className={containerClasses} id={id}>
            {children}
        </div>
    );
};

export default ResponsiveContainer;